import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgWhatsappIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M15.243.021C11.85.211 8.733 1.401 6.1 3.51a16.685 16.685 0 0 0-2.675 2.729 15.925 15.925 0 0 0-3.179 7.714 17.174 17.174 0 0 0-.042 3.616c.16 1.634.606 3.326 1.278 4.843.126.285.488 1.01.663 1.333l.098.181-1.111 4.062C.52 30.223.013 32.077.006 32.111c-.006.036-.002.06.013.06.013 0 1.912-.495 4.218-1.101L8.43 29.97l.495.245a15.71 15.71 0 0 0 3.949 1.366c1.167.239 2.135.324 3.454.305 1.03-.015 1.531-.06 2.455-.218 2.848-.488 5.466-1.73 7.712-3.656a23.9 23.9 0 0 0 1.566-1.555c2.123-2.443 3.443-5.391 3.83-8.549.087-.706.097-.938.097-1.962 0-1.02-.01-1.223-.098-1.952-.486-4.077-2.538-7.778-5.781-10.437a15.9 15.9 0 0 0-5.363-2.86 15.858 15.858 0 0 0-3.403-.645 22.384 22.384 0 0 0-2.101-.032Zm1.824 2.733c3.624.288 6.86 1.965 9.194 4.766a13.167 13.167 0 0 1 2.953 6.944c.079.704.102 1.726.055 2.379a13.173 13.173 0 0 1-2.643 7.067c-.723.96-1.649 1.886-2.609 2.61-2.097 1.578-4.503 2.468-7.142 2.645-.472.032-1.622.013-2.059-.034-2.037-.214-3.78-.785-5.538-1.818l-.44-.258-2.5.655c-1.397.367-2.496.644-2.49.631.005-.015.284-1.028.62-2.253.334-1.224.63-2.31.66-2.412l.052-.184-.214-.337c-.791-1.252-1.33-2.472-1.69-3.816a13.353 13.353 0 0 1-.353-4.898A13.19 13.19 0 0 1 5.73 7.712c2.562-3.217 6.47-5.067 10.547-4.99.288.007.642.02.79.032Z"
      fill="currentColor"
    />
    <path
      d="M10.163 8.606c-.32.075-.548.209-.815.482-.915.934-1.33 1.873-1.384 3.123-.047 1.116.384 2.445 1.203 3.723.169.26.836 1.192 1.126 1.57 1.225 1.594 2.723 3.023 4.182 3.994.996.663 1.9 1.1 3.328 1.606 1.252.442 1.68.527 2.568.506.57-.013.87-.056 1.212-.169.962-.318 1.926-1.032 2.225-1.649.154-.316.294-.894.341-1.387.04-.435-.004-.663-.147-.778-.123-.096-2.105-1.078-3.001-1.483-.83-.378-1.02-.363-1.34.096-.26.369-1.112 1.4-1.302 1.572-.204.188-.381.197-.733.037-.09-.043-.276-.124-.41-.184-1.988-.87-3.548-2.227-4.787-4.166-.271-.423-.337-.56-.337-.7-.002-.152.055-.256.254-.47.181-.194.623-.72.738-.88.04-.058.134-.227.207-.374.126-.258.132-.28.132-.426 0-.175-.02-.24-.203-.66-.064-.147-.358-.85-.652-1.566a38.65 38.65 0 0 0-.604-1.418c-.105-.175-.265-.329-.389-.371-.149-.052-1.22-.073-1.412-.028Z"
      fill="currentColor"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgWhatsappStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgWhatsappIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const WhatsappIcon: any = SvgWhatsappStyle;
export default WhatsappIcon;
